import type { BillingTimelineItem } from './billingTimelineTypes';

const INTERNAL_CLAIM_PATTERNS = [/clearinghouse/i, /edi/i, /277ca/i, /835/i, /candid/i, /stedi/i];

/** Maps stored claim ids to a short client-facing claim number. */
export function toClientClaimNumber(claimId?: string): string | undefined {
  if (!claimId || isInternalClaimDetail(claimId)) return undefined;
  if (/^CLM-/i.test(claimId)) return claimId.toUpperCase();
  const compact = claimId.replace(/[^A-Za-z0-9]/g, '').slice(-8).toUpperCase();
  return compact ? `CLM-${compact}` : undefined;
}

export function filterTimelineForClientPortal(items: BillingTimelineItem[]): BillingTimelineItem[] {
  return items.map((item) => ({
    id: item.id,
    dateOfService: item.dateOfService,
    transactionDate: item.transactionDate,
    type: item.type,
    serviceType: item.serviceType,
    cptCode: undefined,
    providerName: item.providerName,
    totalFee: item.totalFee,
    clientResponsibility: item.clientResponsibility,
    clientPaid: item.clientPaid,
    claimStatus: undefined,
    cardBrand: item.cardBrand,
    cardLast4: item.cardLast4,
    clientClaimNumber: item.clientClaimNumber,
    clientVisibleStatus: item.clientVisibleStatus,
    serviceLabel: item.serviceLabel,
    // Strip internal references and admin-only fields
    sourceReference: item.sourceReference?.reference?.startsWith('Encounter/')
      ? item.sourceReference
      : undefined,
    claimReference: undefined,
    paymentReference: item.paymentReference?.reference?.startsWith('Invoice/')
      ? item.paymentReference
      : undefined,
    authorizationReference: undefined,
    insuranceBilled: undefined,
    insurancePaid: undefined,
    insuranceBalance: undefined,
    writeOff: undefined,
    adminStatusDetails: undefined,
    sourceHref: undefined,
  }));
}

export function isInternalClaimDetail(value?: string): boolean {
  if (!value) return false;
  return INTERNAL_CLAIM_PATTERNS.some((p) => p.test(value));
}

export function clientFriendlyClaimStatus(adminStatus?: string): string {
  if (!adminStatus || isInternalClaimDetail(adminStatus)) return 'Processing';
  const lower = adminStatus.toLowerCase();
  if (lower.includes('denied') || lower.includes('rejected')) return 'Not covered by insurance';
  if (lower.includes('paid') || lower === 'balanced') return 'Insurance paid';
  if (lower.includes('pending') || lower.includes('submitted')) return 'Submitted to insurance';
  if (lower.includes('insurance')) return 'Insurance processing';
  return 'Processing';
}
